import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { templateVersionsUrl } from './helpers';
import { IDocumentAssemblerTemplateVersionResponse } from './types';

// The only route that carries a version's findings. The list route returns summaries alone.
export const useDocumentAssemblerTemplateVersion = (
  templateId: string | null,
  versionId: string | null
) => {
  const { data, error, isLoading, mutate } =
    useSWR<IDocumentAssemblerTemplateVersionResponse>(
      templateId && versionId
        ? `${templateVersionsUrl(templateId)}/${versionId}`
        : null,
      SWRFetcher({ method: 'GET' })
    );

  return { templateVersion: data?.templateVersion, error, isLoading, mutate };
};
